import { LOAD_ALL_SOLUTIONS, LOAD_SINGLE_SOLUTION } from "./SolutionsList.saga";

export const loadAllSolutions = (payload) => ({
  type: LOAD_ALL_SOLUTIONS.LOADING,
  payload,
});

export const loadSingleSolution = (payload) => ({
  type: LOAD_SINGLE_SOLUTION.LOADING,
  payload,
});
